import {
	AppShell,
	Text,
	useMantineTheme,
	Image,
	Card,
	Button,
	Group,
	Menu,
	Grid,
	Pagination,
	Modal,
	Loader,
} from "@mantine/core";
import React from "react";
import Footr from "../../components/Footr";
import Headr from "../../components/Headr";
import { Trash, Notes } from "tabler-icons-react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useState } from "react";
import { getAssets } from "../../API/getAssets";
import AudioIMG from "../../static/svg/audio.svg";
import IMG3D from "../../static/svg/3d-box.svg";
import VideoIMG from "../../static/svg/video.svg";
import PlanVideoIMG from "../../static/svg/video-plane.svg";
import MenuItem from "../../components/MenuItem";
import { deleteAssets } from "../../API/deleteAssets";
import { CDN_URL } from "../../constant";
import { useModals } from "@mantine/modals";
import {
	showSuccessNotification,
	showErrorNotification,
} from "../../utils/Notifications";
import "@google/model-viewer";

function Assets() {
	const AccountId = useSelector(
		(state) => state.userInformationReducer.users.AccountId
	);
	const [filteredArray, setFilteredArray] = useState("");
	const [activePage, setPage] = useState(1);
	const [pages, setPages] = useState(1);
	const [filterdId, setfilterdId] = useState(0);
	const [isViewOpen, setIsViewOpen] = useState([false]);
	const modals = useModals();
	const [loading, setLoading] = useState(false);
	const theme = useMantineTheme();
	const refresh = async () => {
		const result = await getAssets(AccountId, activePage, filterdId, 20);
		setFilteredArray(result.data);
		setPages(result.totalPages);
	};
	const openDeleteModal = (assetId) => {
		modals.openConfirmModal({
			title: "Please confirm your action",
			centered: true,
			styles: {
				modal: { backgroundColor: "#040F1F" },
				title: { color: "#ffffff", fontWeight: "700" },
			},
			children: (
				<Text size="sm">
					Are you sure you want to delete this experience?
				</Text>
			),
			labels: { confirm: "Delete", cancel: "Cancel" },
			confirmProps: { color: "red" },
			onConfirm: () => {
				setLoading(true);
				assetsDeleteHandler(assetId);
			},
		});
	};
	const assetsDeleteHandler = async (assetId) => {
		const resposne = await deleteAssets(AccountId, assetId);
		if (!resposne) {
			showErrorNotification("Asset not Deleted");
			setLoading(false);
		} else {
			showSuccessNotification("Asset Deleted Successfully");
			setLoading(false);
			refresh();
		}
	};
	useEffect(() => {
		const dasbordIMG = async () => {
			const result = await getAssets(
				AccountId,
				activePage,
				filterdId,
				20
			);
			setFilteredArray(result.data);
			setPages(result.totalPages);
		};
		dasbordIMG();
	}, [activePage, filterdId]);
	return (
		<AppShell
			styles={{
				main: {
					minHeight: "calc(100vh - 100px)",
					maxHeight: "auto",
					background:
						theme.colorScheme === "dark"
							? theme.colors.ivisit_dark[0]
							: theme.colors.gray[0],
				},
			}}
			footer={<Footr />}
			header={<Headr />}
		>
			<Group
				sx={{
					Button: {
						color: "white",
						fontWeight: "600",
						padding: "0px 4px",
						fontSize: "12px",
					},
				}}
				p={15}
				style={{
					backgorund: "red",
					width: "100%",
					display: "flex",
					fontWeight: "600",
					fontSize: "12px",
				}}
			>
				<Text>FILTER BY |</Text>
				<Button
					onClick={() => {
						setfilterdId(0);
					}}
					variant="subtle"
				>
					ALL
				</Button>
				<Text>|</Text>
				<Button
					onClick={() => {
						setfilterdId(1);
						setPage(1);
					}}
					variant="subtle"
				>
					IMAGES
				</Button>
				<Text>|</Text>
				<Button
					onClick={() => {
						setfilterdId(2);
						setPage(1);
					}}
					variant="subtle"
				>
					AUDIOS
				</Button>
				<Text>|</Text>
				<Button
					onClick={() => {
						setfilterdId(3);
						setPage(1);
					}}
					variant="subtle"
				>
					SCENES
				</Button>
				<Text>|</Text>
				<Button
					onClick={() => {
						setfilterdId(4);
						setPage(1);
					}}
					variant="subtle"
				>
					PANORAMAS
				</Button>
				<Text>|</Text>
				<Button
					onClick={() => {
						setfilterdId(5);
						setPage(1);
					}}
					variant="subtle"
				>
					3D MODELS
				</Button>
				<Text>|</Text>
				<Button
					onClick={() => {
						setfilterdId(6);
						setPage(1);
					}}
					variant="subtle"
				>
					PLAN VIDEOS
				</Button>
				<Text>|</Text>
				<Button
					onClick={() => {
						setfilterdId(7);
						setPage(1);
					}}
					variant="subtle"
				>
					VIDEOS
				</Button>
			</Group>
			<Grid style={{ minHeight: "calc(100vh - 195px)" }}>
				{filteredArray &&
					filteredArray.map((element) => {
						return (
							<Grid.Col xs={6} sm={6} md={4} lg={2} xl={2}>
								<Card
									key={element?.id}
									style={{
										background: "#09254E",
										padding: "0",
										height: "29vh",
									}}
								>
									<Menu
										offset={1}
										position="bottom-end"
										// styles={{
										// 	dropdown: {
										// 		backgroundColor:
										// 			"rgb(9, 37, 78)",
										// 	},
										// }}
									>
										<Menu.Target>
											<Button
												style={{
													position: "absolute",
													top: "2px",
													right: "2px",
													padding: "0px",
													zIndex: "2",
													width: "25px",
													height: "25px",
													background:
														"rgba(9, 37, 78,0.75)",
													borderRadius: "50%",
												}}
											>
												⋮
											</Button>
										</Menu.Target>
										<Menu.Dropdown
											style={{
												padding: "0px",
												fontSize: "10px",
											}}
										>
											<MenuItem
												Name="Asset Info"
												Icon={Notes}
												menuItemHandler={() => {
													setIsViewOpen({
														opened: true,
														name: element?.Name,
														url: element?.PreviewUrl,
														assetType:
															element?.AssetTypeId,
													});
												}}
											/>
											<MenuItem
												Name="Delete"
												Icon={Trash}
												menuItemHandler={() => {
													openDeleteModal(
														element?.id
													);
												}}
											/>
										</Menu.Dropdown>
									</Menu>
									<Card.Section>
										{element?.AssetTypeId === 2 ? (
											<Image
												style={{
													maxWidth: "20%",
												}}
												m="auto"
												src={AudioIMG}
												alt="Audio"
												height="25vh"
												fit="contain"
											/>
										) : element?.AssetTypeId === 5 ? (
											<Image
												style={{
													maxWidth: "20%",
												}}
												m="auto"
												src={IMG3D}
												alt="3D"
												height="25vh"
												fit="contain"
											/>
										) : element?.AssetTypeId === 6 ? (
											<Image
												style={{
													maxWidth: "20%",
												}}
												m="auto"
												src={PlanVideoIMG}
												alt="Plan Video"
												height="25vh"
												fit="contain"
											/>
										) : element?.AssetTypeId === 7 ? (
											<Image
												style={{
													maxWidth: "20%",
												}}
												m="auto"
												src={VideoIMG}
												alt="Video"
												height="25vh"
												fit="contain"
											/>
										) : (
											<Image
												src={`${CDN_URL}${
													element?.PreviewUrl
														? element?.PreviewUrl
														: ""
												}`}
												height="25vh"
												alt="Images"
											/>
										)}
									</Card.Section>
									<Text
										style={{
											color: "white",
											textAlign: "center",
											textOverflow: "ellipsis",
											whiteSpace: "nowrap",
											fontSize: "14px",
											marginTop: "3px",
											overflow: "hidden",
										}}
										weight={500}
										mt="md"
										ml={7}
										mr={7}
									>
										{element?.Name}
									</Text>
								</Card>
							</Grid.Col>
						);
					})}
			</Grid>
			{pages !== 1 && (
				<Pagination
					sx={{
						Button: {
							background: "#09254E",
							fontWeight: "600",
							padding: "0px 4px",
							fontSize: "12px",
							border: "none",
						},
						"Button:first-child": {
							backgroundColor: "#14B8E1",
							border: "none",
						},
						"Button:last-child": {
							backgroundColor: "#14B8E1",
							border: "none",
						},
					}}
					page={activePage}
					onChange={setPage}
					mt={15}
					total={pages}
					size="sm"
					style={{
						justifyContent: "center",
						color: "pink",
					}}
				/>
			)}
			<Modal
				centered
				size="lg"
				opened={isViewOpen?.opened}
				onClose={() => setIsViewOpen({ opened: false })}
				title={isViewOpen?.name}
				styles={{
					modal: { backgroundColor: "#040F1F" },
					title: { color: "#ffffff", fontWeight: "700" },
				}}
			>
				{(isViewOpen?.assetType === 6 ||
					isViewOpen?.assetType === 7) && (
					<video width="100%" controls>
						<source
							src={CDN_URL + isViewOpen?.url}
							type="video/mp4"
						/>
						Your browser does not support the video tag.
					</video>
				)}
				{(isViewOpen?.assetType === 1 ||
					isViewOpen?.assetType === 3 ||
					isViewOpen?.assetType === 4) && (
					<Image src={CDN_URL + isViewOpen?.url} fit="cover" />
				)}
				{isViewOpen?.assetType === 2 && (
					<audio controls>
						<source
							src={CDN_URL + isViewOpen?.url}
							type="audio/mpeg"
						/>
						Your browser does not support the audio element.
					</audio>
				)}
				{isViewOpen?.assetType === 5 && (
					<Group
						position="center"
						style={{ width: "100%", height: "450px" }}
					>
						<model-viewer
							style={{
								width: "100%",
								height: "100%",
							}}
							camera-controls
							src={CDN_URL + isViewOpen?.url}
						/>
					</Group>
				)}
			</Modal>
			{loading && (
				<div className="LoadingModal">
					<Loader className="LoadingModal_loader" />
				</div>
			)}
		</AppShell>
	);
}

export default Assets;
